import React from 'react';

function ScheduleLegend({ translations }) {
  const t = translations.legend;

  const items = [
    { key: 'specialist', label: t.specialist, className: 'doctor-schedule-mgmt__legend-dot--specialist' },
    { key: 'executive', label: t.executive, className: 'doctor-schedule-mgmt__legend-dot--executive' },
    { key: 'teleconsultation', label: t.teleconsultation, className: 'doctor-schedule-mgmt__legend-dot--teleconsultation' },
  ];

  return (
    <div className="doctor-schedule-mgmt__legend mb-3">
      <span className="doctor-schedule-mgmt__legend-label">{t.title}</span>
      {items.map((item) => (
        <span className="doctor-schedule-mgmt__legend-item" key={item.key}>
          <span className={`doctor-schedule-mgmt__legend-dot ${item.className}`} />
          <span>{item.label}</span>
        </span>
      ))}
    </div>
  );
}

export default ScheduleLegend;
